import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Button } from '@occc/ui-design-system';

import { RetailerNetworkLocationsAndGroups } from './retailer-network-locations-and-groups.component';

import { routeCreator } from '../retailer-connect.utils';
import { RetailerNetworkUpdateHandler } from '../retailer-connect.types';
import { useBreadcrumbLinks } from '../hooks/use-breadcrumb-links.hook';

type RetailerNetworkLocationsConfigurationContainerProps = {
  retailerNetworkUuid: string;
  retailerNetworkUpdate: RetailerNetworkUpdateHandler;
  customerId: string;
};

const RetailerNetworkLocationsConfigurationContainer = ({
  retailerNetworkUuid,
  retailerNetworkUpdate,
  customerId,
}: RetailerNetworkLocationsConfigurationContainerProps) => {
  useBreadcrumbLinks();
  const navigate = useNavigate();

  return (
    <>
      <RetailerNetworkLocationsAndGroups
        retailerNetworkUuid={retailerNetworkUuid}
        retailerNetworkUpdate={retailerNetworkUpdate}
        customerId={customerId}
      />
      <Box m={1} display='flex' justifyContent='flex-end' alignItems='flex-end' gap={2}>
        <Button
          variant='text'
          color='primary'
          onClick={() =>
            navigate(
              retailerNetworkUuid
                ? routeCreator.overview(retailerNetworkUuid)
                : routeCreator.base(),
            )
          }
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() =>
            navigate(routeCreator.configurationUpdateNetworkUsers(retailerNetworkUuid))
          }
          data-testid='retailer-network-configuration-button'
        >
          Continue
        </Button>
      </Box>
    </>
  );
};

export default RetailerNetworkLocationsConfigurationContainer;
